import { render } from "./PimProductsDetailCategories.vue?vue&type=template&id=09ec1f0a&scoped=true&ts=true"
import script from "./PimProductsDetailCategories.vue?vue&type=script&lang=ts"
export * from "./PimProductsDetailCategories.vue?vue&type=script&lang=ts"

import "./PimProductsDetailCategories.vue?vue&type=style&index=0&id=09ec1f0a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ec1f0a"]])

export default __exports__